import { createContext, useContext, useEffect, useMemo, useState, type ReactNode } from 'react'

export type Lang = 'ru' | 'en'

const STORAGE_KEY = 'sensor.web.lang'
const COOKIE_KEY = 'sensor_web_lang'
const COOKIE_DOMAIN = '.sensor-tg.tech'

const TEXT: Record<string, string> = {
  'Сегодня': 'Today',
  'Проекты': 'Projects',
  'Лиды': 'Leads',
  'Источники': 'Sources',
  'Чат по источникам': 'Source chat',
  'Настройки': 'Settings',
  'Дашборд': 'Dashboard',
  'Организация': 'Organization',
  'Организации': 'Organizations',
  'Управление в боте': 'Manage in bot',
  'Рабочее место': 'Workspace',
  'Аналитика': 'Analytics',
  'Отчёты': 'Reports',
  'Тариф:': 'Plan:',
  'Тариф': 'Plan',
  'Триал': 'Trial',
  'демо': 'demo',
  'Подключите тариф, чтобы не потерять источники.': 'Upgrade your plan to keep your sources.',
  'Выйти': 'Log out',
  'Открыть бота': 'Open bot',
  'Обзор': 'Overview',
  'Лидов всего': 'Total leads',
  'Найдено': 'Found',
  'Горячих лидов': 'Hot leads',
  'Горячих': 'Hot',
  'Без фидбека': 'No feedback',
  'Источников': 'Sources',
  'Нет проектов. Создайте проект через': 'No projects yet. Create a project via',
  'Telegram-бота': 'the Telegram bot',
  'Сохранено': 'Saved',
  'Сохранить': 'Save',
  'Добавить': 'Add',
  'Загрузка…': 'Loading...',
  'Загрузка...': 'Loading...',
  'Название': 'Name',
  'Название проекта': 'Project name',
  'Описание (raw_input)': 'Description (raw_input)',
  'Описание бизнеса и целевой аудитории…': 'Business and target audience description...',
  'Статус:': 'Status:',
  'Привязка юзербота': 'Userbot binding',
  '— не выбран —': '— not selected —',
  'Привязать': 'Bind',
  'Управление жизненным циклом': 'Lifecycle management',
  'Активировать': 'Activate',
  'Пауза': 'Pause',
  'Возобновить': 'Resume',
  'Удалить': 'Delete',
  'Основное': 'Main',
  'Ключевые слова': 'Keywords',
  'Исключения': 'Exclusions',
  'AI-логика': 'AI logic',
  'Пользователи': 'Users',
  'Активен': 'Active',
  'Черновик': 'Draft',
  'Нет ключевых слов': 'No keywords',
  'Добавить через запятую или Enter…': 'Add comma-separated values or press Enter...',
  'Слова-исключения': 'Exclude keywords',
  'AI-подсказка для фильтрации лидов': 'AI prompt for lead filtering',
  'Опишите, кого именно вы ищете и как AI должен квалифицировать лидов…': 'Describe who you are looking for and how AI should qualify leads...',
  'Отслеживаемые пользователи': 'Tracked users',
  'Хранятся только @username (без числовых ID).': 'Only @usernames are stored, without numeric IDs.',
  'Нет пользователей': 'No users',
  'Новый проект': 'New project',
  'Опишите ваш бизнес и кого вы ищете…': 'Describe your business and who you are looking for...',
  'Отмена': 'Cancel',
  'Генерация…': 'Generating...',
  'Создать': 'Create',
  'Обновлён:': 'Updated:',
  'лидов': 'leads',
  'горячих': 'hot',
  'источников': 'sources',
  'Источники с лидами': 'Sources with leads',
  '+ Новый проект': '+ New project',
  'Проектов пока нет. Нажмите': 'No projects yet. Click',
  'чтобы создать первый.': 'to create the first one.',
  'Релевантные сообщения из ваших источников. Отметьте 👍/👎 — SENSOR станет точнее.': 'Relevant messages from your sources. Mark 👍/👎 so SENSOR gets more accurate.',
  'Все проекты': 'All projects',
  'Поиск по тексту, причине AI…': 'Search by text or AI reason...',
  'Поиск по тексту, причине AI, источнику…': 'Search by text, AI reason, or source...',
  'Только горячие': 'Hot only',
  'Снять': 'Clear',
  'Не уверен': 'Unsure',
  'Сбросить': 'Reset',
  'Дата': 'Date',
  'Сообщение / причина AI': 'Message / AI reason',
  'Источник': 'Source',
  'Проект': 'Project',
  'Фидбэк': 'Feedback',
  'Статус': 'Status',
  'Лидов не найдено — попробуйте изменить фильтры.': 'No leads found. Try changing the filters.',
  'Лидов пока нет. Создайте проект и добавьте источники через бота.': 'No leads yet. Create a project and add sources via the bot.',
  'Лидов не найдено': 'No leads found',
  'Показано': 'Showing',
  'из': 'of',
  'Назад': 'Back',
  'Вперёд': 'Forward',
  'Потяните, чтобы изменить ширину панели': 'Drag to resize the panel',
  'Детали лида': 'Lead details',
  'К списку': 'Back to list',
  'Горячий лид': 'Hot lead',
  'Предыдущий': 'Previous',
  'Следующий': 'Next',
  'Закрыть': 'Close',
  'Автор:': 'Author:',
  'Причина AI': 'AI reason',
  'Уверенность': 'Confidence',
  'Ваш фидбэк': 'Your feedback',
  'Лид': 'Lead',
  'Не лид': 'Not a lead',
  'Статус воронки': 'Pipeline status',
  'Открыть в Telegram': 'Open in Telegram',
  'Новый': 'New',
  'Взят в работу': 'In progress',
  'Конвертирован в заказ': 'Won',
  'Отказ': 'Lost',
  'ещё не разбирали': 'not reviewed yet',
  'связываемся с заказчиком': 'contacting the customer',
  'стал заказом': 'converted to an order',
  'не подошёл или отказался': 'not a fit or declined',
  'высокий': 'high',
  'средний': 'medium',
  'низкий': 'low',
  'Удалён': 'Removed',
  'Доступ:': 'Access:',
  'Причина:': 'Reason:',
  'Последнее сканирование:': 'Last scan:',
  'Последний лид:': 'Last lead:',
  'Удалён:': 'Removed:',
  'Смотреть лиды →': 'View leads →',
  'Ошибка при удалении': 'Delete failed',
  'Удаление...': 'Deleting...',
  'Удалить источник': 'Delete source',
  'Импорт из папок Telegram': 'Import from Telegram folders',
  'Сначала привяжите юзербот к проекту (вкладка проекта).': 'Bind a userbot to the project first in the project tab.',
  'Синхронизирую диалоги Telegram…': 'Syncing Telegram dialogs...',
  'Не удалось синхронизировать диалоги.': 'Failed to sync dialogs.',
  'Повтор...': 'Retrying...',
  'Повторить': 'Retry',
  'Папка': 'Folder',
  'Все диалоги': 'All dialogs',
  'Загрузка диалогов…': 'Loading dialogs...',
  'Нет доступных диалогов.': 'No available dialogs.',
  'Снять всё': 'Clear all',
  'Выбрать всё': 'Select all',
  'уже добавлен': 'already added',
  'Ошибка импорта': 'Import failed',
  'Импорт...': 'Importing...',
  'Источники не найдены': 'No sources found',
  'Юзербот': 'Userbot',
  'Лидов': 'Leads',
  'Доступ': 'Access',
  'Посл. лид': 'Last lead',
  'Лидов: по убыванию': 'Leads: high to low',
  'Лидов: по возрастанию': 'Leads: low to high',
  'Последний лид: новые': 'Last lead: newest',
  'Последний лид: старые': 'Last lead: oldest',
  'Источники — проект': 'Sources — project',
  'Импорт из папок': 'Import from folders',
  'Проверить доступ': 'Check access',
  'Проверка...': 'Checking...',
  'Экспорт лидов CSV': 'Export leads CSV',
  'Экспорт...': 'Exporting...',
  'Ошибка добавления': 'Add failed',
  'Веб-панель управления лидами': 'Lead management web dashboard',
  'Выполняется вход…': 'Signing in...',
  'Ссылка устарела или уже была использована. Запросите новую через бота.': 'The link has expired or was already used. Request a new one from the bot.',
  'Ошибка входа. Попробуйте ещё раз.': 'Sign-in failed. Try again.',
  'Открыть @sensor_tg_bot': 'Open @sensor_tg_bot',
  'Войдите через Telegram-бота': 'Sign in via the Telegram bot',
  'Откройте': 'Open',
  'и нажмите кнопку': 'and press',
  'Бот пришлёт одноразовую ссылку для входа.': 'The bot will send a one-time sign-in link.',
  'Ссылка действительна 5 минут и используется один раз': 'The link is valid for 5 minutes and can be used once',
  'Подключить юзербот': 'Connect userbot',
  'Готовим QR-код…': 'Preparing QR code...',
  'QR-код для входа': 'Sign-in QR code',
  'Откройте Telegram на телефоне': 'Open Telegram on your phone',
  'Настройки → Устройства → Подключить устройство': 'Settings → Devices → Link desktop device',
  'Наведите камеру на этот QR-код': 'Point the camera at this QR code',
  'Ожидаем сканирование…': 'Waiting for scan...',
  'QR-код истёк': 'QR code expired',
  'Ошибка подключения': 'Connection failed',
  'Юзербот подключён': 'Userbot connected',
  'Готово': 'Done',
  'только что': 'just now',
  'Профиль': 'Profile',
  'Организация и аккаунт': 'Organization and account',
  'Название организации': 'Organization name',
  'Это имя показывается в левом меню.': 'This name is shown in the left menu.',
  'Ошибка': 'Error',
  'Сохраняем…': 'Saving...',
  'Часовой пояс': 'Time zone',
  'Используется при выборе «Своего периода» при создании чата по источникам.': 'Used for the custom period when creating a source chat.',
  'Юзербот (Telegram-аккаунт)': 'Userbot (Telegram account)',
  'Источники в «Чат по источникам» зависят от активного юзербота.': 'Sources in Source chat depend on the active userbot.',
  'Ошибка загрузки': 'Loading failed',
  'Нет доступных юзерботов': 'No userbots available',
  'Переключаем…': 'Switching...',
  'активен': 'active',
  'Единственный юзербот — переключение недоступно.': 'Only one userbot is available, so switching is disabled.',
  '+ Подключить юзербот': '+ Connect userbot',
  'Подключение через QR-код. Если на аккаунте включена 2FA — используйте Telegram-бота.': 'Connect via QR code. If 2FA is enabled on the account, use the Telegram bot.',
  'Управление проектами и источниками': 'Project and source management',
  'Создание проектов, добавление источников, настройка фильтров и ключевых слов выполняется через Telegram-бота.': 'Create projects, add sources, and configure filters and keywords via the Telegram bot.',
  'Чаты по источникам': 'Source chats',
  'Новый чат': 'New chat',
  'Сессии': 'Sessions',
  'Сначала недавние': 'Newest first',
  'Сначала старые': 'Oldest first',
  'По юзерботу': 'By userbot',
  'Все': 'All',
  'Спросите свои Telegram-источники': 'Ask your Telegram sources',
  'Новый чат по источникам': 'New source chat',
  'Источники сессии': 'Session sources',
  'Выберите сессию': 'Select a session',
  'Все мои чаты': 'All my chats',
  'Только источники проектов': 'Project sources only',
  'Объём': 'Scope',
  'Вопрос': 'Question',
  'Выбрано:': 'Selected:',
  'Последние N сообщений': 'Latest N messages',
  'Соберём заданное число последних сообщений из каждой группы.': 'Collect the selected number of latest messages from each group.',
  'сообщений:': 'messages:',
  'Период': 'Period',
  'Соберём все сообщения за выбранный промежуток времени.': 'Collect all messages for the selected period.',
  'Свой период (с даты/времени)': 'Custom period (from date/time)',
  'Соберём сообщения начиная с указанной даты и времени.': 'Collect messages starting from the selected date and time.',
  'Чем больше объём, тем дольше сбор и выше расход ingest-кредитов.': 'Larger scope takes longer and uses more ingest credits.',
  'Ваш вопрос по этим источникам': 'Your question for these sources',
  'Напр.: что обсуждали про доставку из Китая и какие цены называли?': 'Example: what did people discuss about delivery from China and what prices were mentioned?',
  'Далее': 'Next',
  'Создать чат': 'Create chat',
  'Создаём…': 'Creating...',
  'Не удалось получить ответ — попробуйте ещё раз': 'Failed to get an answer. Try again.',
  'Обновить список чатов': 'Refresh chat list',
  'Поиск по названию…': 'Search by name...',
  'Ничего не найдено': 'Nothing found',
  // AI logic editor (project drawer)
  'Кого ищем': 'Who we are looking for',
  'Критерии AI': 'AI criteria',
  'Считать лидом': 'Lead',
  'Контекст': 'Context',
  'Целевой автор': 'Target author',
  'Не путать с ролью': 'Do not confuse with role',
  'Подходящие примеры': 'Good examples',
  'Примеры не-лидов': 'Non-lead examples',
  'Итоговая инструкция для AI': 'Final AI instruction',
  'Инструкция для AI': 'AI instruction',
  'Поля': 'Fields',
  'Текст': 'Text',
  'Редактировать': 'Edit',
  'Описание проекта пока не задано.': 'Project description is not set yet.',
  'Критерии AI пока не заданы.': 'AI criteria are not set yet.',
  'AI-логика пока не задана.': 'AI logic is not set yet.',
  'автор ищет подрядчика, услугу, поставщика или решение': 'author is looking for a contractor, service, supplier, or solution',
  'ниша, география, продукт, тип сделки': 'niche, geography, product, deal type',
  'покупатель, клиент, владелец бизнеса, ЛПР': 'buyer, client, business owner, decision maker',
  'подрядчик, продавец, кандидат, рекламодатель, тот кто ищет сотрудника': 'contractor, seller, candidate, advertiser, job poster',
  'нужен подрядчик для CRM кто настроит аналитику': 'need a contractor for CRM, who can set up analytics',
  'делаем CRM под ключ ищем менеджера по продажам': 'we build CRM end to end, looking for a sales manager',
  'Опишите простыми словами, кто считается лидом, кто нет и какие нюансы важны.': 'Describe in plain language who counts as a lead, who does not, and what nuances matter.',
  // Project drawer: tabs, Telegram access badge, watch tab
  'Мониторинг пользователя': 'User monitoring',
  'Телеграм доступ': 'Telegram access',
  'Телеграм доступ:': 'Telegram access:',
  'Источники проекта →': 'Project sources →',
  'Аккаунт, через который SENSOR читает источники проекта': 'The account SENSOR uses to read the project sources',
  'Не подключён': 'Not connected',
  'SENSOR будет отмечать сообщения этих пользователей в источниках проекта.': 'SENSOR will flag messages from these users in the project sources.',
  'Описание': 'Description',
  'Управление проектом': 'Project management',
  'Удалить проект': 'Delete project',
  'Дублировать проект': 'Duplicate project',
  'Лиды, настройки и привязки проекта будут удалены. Это действие нельзя отменить.': 'The project leads, settings, and bindings will be deleted. This action cannot be undone.',
  'Будет создан новый проект со словами, AI-промптом, источниками и настройками. Лиды и результаты сканирования не копируются. Юзербот привязывается заново.': 'A new project will be created with keywords, AI prompt, sources and settings. Leads and scan results are not copied. The userbot must be re-bound.',
  'Дублировать': 'Duplicate',
}

const REPLACEMENTS: Array<[RegExp, (m: RegExpMatchArray) => string]> = [
  [/^(\d+)\s+лидов во всех проектах$/, (m) => `${m[1]} leads across all projects`],
  [/^(\d+)\s+лидов$/, (m) => `${m[1]} leads`],
  [/^(\d+)\s+источников$/, (m) => `${m[1]} sources`],
  [/^(\d+)\s+из\s+(\d+)\s+источников во всех проектах$/, (m) => `${m[1]} of ${m[2]} sources across all projects`],
  [/^Проект #?(\d+)$/, (m) => `Project #${m[1]}`],
  [/^Источник (\d+)$/, (m) => `Source ${m[1]}`],
  [/^Добавлено: (\d+)$/, (m) => `Added: ${m[1]}`],
  [/^Доступно: (\d+), недоступно: (\d+)$/, (m) => `Available: ${m[1]}, unavailable: ${m[2]}`],
  [/^Ошибка (\d+)$/, (m) => `Error ${m[1]}`],
  [/^Импортировать выбранные \((\d+)\)$/, (m) => `Import selected (${m[1]})`],
  [/^Диалоги \((\d+)\)$/, (m) => `Dialogs (${m[1]})`],
  [/^(\d+) мин назад$/, (m) => `${m[1]} min ago`],
  [/^(\d+) ч назад$/, (m) => `${m[1]} h ago`],
  [/^(\d+) дн назад$/, (m) => `${m[1]} d ago`],
  [/^(\d+) мин$/, (m) => `${m[1]} min`],
  [/^(\d+) ч$/, (m) => `${m[1]} h`],
  [/^(\d+) дн$/, (m) => `${m[1]} d`],
]

function translateText(value: string): string {
  const compact = value.replace(/\s+/g, ' ').trim()
  if (!compact) return value
  const exact = TEXT[compact]
  if (exact) return value.replace(compact, exact)
  for (const [regex, render] of REPLACEMENTS) {
    const match = compact.match(regex)
    if (match) return value.replace(compact, render(match))
  }
  return value
}

function readCookieLang(): Lang | null {
  if (typeof document === 'undefined') return null
  const cookies = document.cookie.split(';').map((part) => part.trim())
  const match = cookies.find((cookie) => cookie.startsWith(`${COOKIE_KEY}=`))
  if (!match) return null
  const value = match.slice(COOKIE_KEY.length + 1)
  return value === 'en' ? 'en' : 'ru'
}

function writeCookieLang(lang: Lang) {
  if (typeof document === 'undefined') return
  const maxAge = 60 * 60 * 24 * 365
  const domainPart = location.hostname.endsWith('sensor-tg.tech') ? `; Domain=${COOKIE_DOMAIN}` : ''
  document.cookie = `${COOKIE_KEY}=${lang}; Path=/; Max-Age=${maxAge}; SameSite=Lax${domainPart}`
}

const originalText = new WeakMap<Text, string>()
const originalAttrs = new WeakMap<Element, Map<string, string>>()
const ATTRS = ['placeholder', 'title', 'aria-label', 'data-screen-label', 'alt']

function translateNode(node: Node, lang: Lang) {
  if (node.nodeType === Node.TEXT_NODE) {
    const textNode = node as Text
    const current = textNode.nodeValue ?? ''
    let original = originalText.get(textNode)
    if (original == null) {
      original = current
      originalText.set(textNode, original)
    } else if (lang === 'en' && current !== translateText(original)) {
      original = current
      originalText.set(textNode, original)
    }
    const next = lang === 'en' ? translateText(original) : original
    if (current !== next) textNode.nodeValue = next
    return
  }

  if (node.nodeType !== Node.ELEMENT_NODE) return
  const element = node as Element
  if (element.tagName === 'SCRIPT' || element.tagName === 'STYLE') return

  for (const attr of ATTRS) {
    const current = element.getAttribute(attr)
    if (current == null) continue
    let attrs = originalAttrs.get(element)
    if (!attrs) {
      attrs = new Map()
      originalAttrs.set(element, attrs)
    }
    if (!attrs.has(attr)) attrs.set(attr, current)
    const original = attrs.get(attr) ?? current
    const next = lang === 'en' ? translateText(original) : original
    if (current !== next) element.setAttribute(attr, next)
  }

  element.childNodes.forEach((child) => translateNode(child, lang))
}

interface I18nContextValue {
  lang: Lang
  setLang: (lang: Lang) => void
}

const I18nContext = createContext<I18nContextValue | null>(null)

export function I18nProvider({ children }: { children: ReactNode }) {
  const [lang, setLangState] = useState<Lang>(() => {
    if (typeof window === 'undefined') return 'ru'
    const cookieLang = readCookieLang()
    if (cookieLang) return cookieLang
    try {
      const stored = window.localStorage?.getItem(STORAGE_KEY)
      if (stored === 'en' || stored === 'ru') return stored
    } catch {
      /* ignore storage failures */
    }
    return 'ru'
  })

  const value = useMemo(
    () => ({
      lang,
      setLang(next: Lang) {
        setLangState(next)
        try {
          window.localStorage?.setItem(STORAGE_KEY, next)
        } catch {
          /* storage can be unavailable in embedded browsers */
        }
        writeCookieLang(next)
      },
    }),
    [lang],
  )

  useEffect(() => {
    document.documentElement.lang = lang
    translateNode(document.body, lang)

    // In Russian the DOM already contains the source strings. Observing React's
    // text updates here would restore a previously cached string (for example,
    // keep the first breadcrumb label after navigation).
    if (lang !== 'en') return

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => translateNode(node, lang))
        if (mutation.type === 'characterData') translateNode(mutation.target, lang)
        if (mutation.type === 'attributes') translateNode(mutation.target, lang)
      }
    })
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ATTRS,
    })
    return () => observer.disconnect()
  }, [lang])

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>
}

export function useI18n() {
  const value = useContext(I18nContext)
  if (!value) throw new Error('useI18n must be used inside I18nProvider')
  return value
}
